var Admin__OrganizationsController;

import OrganizationNavigator from 'trunks/vue/admin/compositions/organizations_sidebar/organization_navigator.js';

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import OrganizationApplicationsContainer from 'trunks/vue/admin/components/organizations/users_organizations_container/organization_applications.js';

export default Admin__OrganizationsController = (function() {
  class Admin__OrganizationsController extends Skylark.App.BaseController {
    index() {
      var page;
      page = this.getVars();
      this._generateOrganizationSidebarView(this.getIds()[0]);
      return new OrganizationApplicationsContainer({
        el: DomMaster.find("#js-organization-container").node,
        propsData: {
          organization: page.organization,
          organizationApplicationsCount: page.organization_applications_count
        }
      });
    }

  };

  Admin__OrganizationsController.include(GenerateMorePopover);

  Admin__OrganizationsController.include(OrganizationNavigator);

  return Admin__OrganizationsController;

}).call(this);
